<template>
    <div class="myShopItemDetail">
        <template v-if="data">
            <!-- 商品详情 {{ $route.params.id }} -->
            <h2>商品详情</h2>
            <div class="block-detail-main">
                <!-- 跑马灯 -->
                <div class="block-detail-main_left">
                    <el-carousel height="400px" :interval="5000" arrow="always" ref="mainCarousel">
                        <el-carousel-item v-for="(item,index) in carouselItems" :key="item.url+index">
                            <div class="carouselImgWrap" @click="handleClickCarouselItem(item)">
                                <img class="carouselImg" :src="item.type === 'video' ? item.videoCover : item.url" />
                                <div class="video-icon-wrap" v-if="item.type === 'video'">
                                    <i class="el-icon-video-play" />
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <!-- 标题及相关信息 -->
                <div class="block-detail-main_right">
                    <div class="dis-flex align-center mgtb16">
                    <h2 class="mgtb0" v-if="showList.title">{{ data.title }}</h2>
                    </div>
                    <OperationalRecordCard v-if="data.supplyOperateDataVo" :operationalData="data.supplyOperateDataVo || {}"/>
                    <!-- 浏览量 收藏人数 铺货次数 -->
                    <div class="numCountRow" v-if="identity != 'unLoginShare'">
                        <div class="numCountRow-item">
                            <span class="numCountRow-item_label">浏览人数</span>
                            {{ data.viewCount || 0 }}
                        </div>
                        <div class="numCountRow-item">
                            <span class="numCountRow-item_label">收藏人数</span>
                            {{ data.favoriteCount || 0 }}
                        </div>
                        <div class="numCountRow-item">
                            <span class="numCountRow-item_label">铺货次数</span>
                            {{ data.publicCount || 0 }}
                        </div>
                        <el-popover
                            class="data-row_help"
                            placement="top"
                            title="近30天统计数"
                            :content="`最近更新日期：${yesterday}，每日2点更新`"
                            trigger="hover">
                            <i slot="reference" class="el-icon-bangzhuzhongxin" />
                        </el-popover>
                    </div>
                    <div style="display:inline-block; float:right; margin-top:-30px">
                        <div class="gain" v-if=" showList.commissionPrice || showList.commissionScale">
                            <div v-if="showList.commissionPrice"><span class="zuan">赚</span><span class="num">{{selectedSku && selectedSku.commissionPrice || '-'}}</span></div>
                            <div v-if="showList.commissionScale"><span class="yong">拥</span>{{selectedSku && selectedSku.commissionScale || '-'}}</div>
                        </div>
                    </div>
                    <!-- 分销价模块 -->
                    <div class="distributionPriceRow">
                        <DistributionPrice v-if="showList.distributePrice" :disToSupDetail="disToSupDetail" :price="selectedSku && selectedSku.levelDistributionPrice || data.levelDistributionPrice" :precision="amountPrecision"/>
                        <div style="height: 30px;" class="DistributionPrice" v-if="showList.marketPrice">
                        市场价：
                        <AmountDigitText :value="selectedSku && selectedSku.marketPrice" :precision="amountPrecision"/>
                        </div>
                    </div>
                    <!-- 可铺货平台 -->
                    <CanPublishPlatform v-if="showList.canPublish" :canPublishPlatform="data.canPublishPlatform" />
                    <!-- 款式信息 -->
                    <div class="numCountRow mb-10 mt-10">
                        <div class="numCountRow-item" v-if="showList.outerId">
                            <span class="numCountRow-item_label">款式编码：</span>
                            {{ data.outerId }}
                        </div>
                        <template v-if="!data.pureType && showList.stock">
                            <div class="numCountRow-item">
                                <span class="numCountRow-item_label">库存：</span>
                                {{ (selectedSku &&  selectedSku.stock) || 0 }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="numCountRow-item">
                            <span class="numCountRow-item_label">库存：</span>
                            <template v-if="identity == 'unLoginShare'">
                                ***
                            </template>
                            <template v-else>
                                {{ (data.pureType ? data.stock : (selectedSku && selectedSku.stock)) || 0 }}
                            </template>
                        </div>
                        </template>
                        <template v-if="showList.freightPrice">
                            <div class="numCountRow-item">
                                <span class="numCountRow-item_label">运费：</span>
                                <AmountDigitText :value="getFreightPrice" :precision="amountPrecision"/>
                                <span v-if="skuFreightPrice.length > 1">元起</span>
                            </div>
                        </template>
                    </div>
                    <div class="mb-10" v-if="data.receiveAddress">
                        <span class="numCountRow-item_label">退款地址：</span>
                        {{ data.receiveAddress || '-' }}
                        <el-button 
                            v-if="data.receiveAddress"
                            v-clipboard:copy="data.receiveAddress"
                            v-clipboard:success="handleOnCopy"
                            type="link" 
                        >复制</el-button>
                    </div>
                    <!-- 规格按钮部分 -->
                    <div>
                        <DetailSpecificationButtons
                            :specifications="data.specifications"
                            :skuList="data.skuList"
                            @change="specificationChange"
                            />
                    </div>
                    <div class="numCountRow-item num-wrapper" v-if="isSupplierProduct && !readonly">
                        <span class="numCountRow-item_label">数量：</span>
                        <el-input-number :disabled="!selectedSku" v-model="purchaseNum" @manual-input="changePurchaseNum" @change="changePurchaseNum" :min="0" size="mini"></el-input-number>
                    </div>
                    <div v-if="totalSelectedSku.length && showSkuList" class="skus-select-wraper">
                        <el-table :data="totalSelectedSku" :show-header="false" :stripe="false">
                            <el-table-column prop="imageUrl" width="180" label="图片">
                                <template slot-scope="scope">
                                    <img :src="scope.row.imageUrl || no_pic" style="width: 30px; height: 30px; margin-top:10px;">
                                </template>
                            </el-table-column>
                            <el-table-column v-for="(spec, index) in totalSelectedSku[0].skuSpecifications" :label="spec.name" :key="index">
                                <template slot-scope="scope">
                                    {{ scope.row.skuSpecifications.find(s => s.name === spec.name).value }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="num" label="数量"></el-table-column>
                            <el-table-column>
                                <template slot-scope="scope">
                                    <span class="red" v-if="errorSkuIds.includes(scope.row.skuId)">该商品已失效</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="handleRemove(scope.row.key)" type="text" size="small">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="totalSelectedSku.length && isSupplierProduct && purchaseTotal!==0 && !readonly" class="total-wrapper">
                        <div class="left">
                            <div class="total">共 <span>{{ purchaseTotal }}</span> 件</div>
                            <div class="line"></div>
                            <div class="price">
                                <span class="num2">￥ <AmountDigitText :value="(+priceTotal || 0)" :precision="amountPrecision"/></span>
                            </div>
                        </div>
                        <div class="right" @click="changeSkuListStatus">
                            已选清单
                            <i v-if="showSkuList" class="el-icon-arrow-up"></i>
                            <i v-else class="el-icon-arrow-down"></i>
                        </div>
                    </div>
                    <div class="mgtb40" v-if="isSupplierProduct && !readonly">
                    <el-button type="primary" class="mgr20" @click="()=>toShoppingCart('xd', data)" :disabled="purchaseTotal===0">立即下单</el-button>
                    <el-button type="primary" plain class="mgr20" @click="()=>shoppingCartAdd('', data)" :disabled="purchaseTotal===0">加采购车</el-button>
                    <el-button type="primary" class="mgr20 el-button-plain" @click="shelvesClick">一键铺货</el-button>
                    <el-button type="primary" class="mgr20 el-button-plain" @click="joinClick">加入分销商品</el-button>
                    <el-button type="primary" class="el-button-plain" @click="updateClick">更新分销商品</el-button>
                    </div>
                </div>
            </div>
            <div v-if="data.description" class="block-detail-des">
                <span class="block-detail-des_label">商品描述：</span>
                <span style="white-space: pre-wrap;">{{ data.description }}</span>
            </div>
            <div class="block-detail-spTable" v-if="!data.pureType">
                <SkuTable
                    :specifications="data.specifications"
                    :skuList="data.skuList"
                    :skuConfigList="skuConfigList"
                    :skuConfigWidthList="skuConfigWidthList"
                    :precision="amountPrecision"
                />
            </div>
            <div class="block-detail-desImgs">
                <el-image class="block-detail-desImgs_img" v-for="(url, index) in data.detailImages" :key="url" :src="url" :lazy="![0,1].includes(index)"></el-image>
            </div>
        </template>

        <el-dialog
            title="查看图片"
            width="auto"
            :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <div style="display: none">
            <ShopGoodsList
                :supplierCompanyId="supplierCompanyId"
                ref="shopGoodsRef"
                :hideGoodsList="true"
                :showWarning="false"
            />
            <PrivateAbnormal ref="privateAbnormal" :isInCooperation="isInCooperation"/>
            <DistributeAbnormal ref="distributeAbnormal" />
        </div>
    </div>
</template>

<script>
import DistributionPrice from '../components/List/components/ListPart/components/DistributionPrice.vue'
import CanPublishPlatform from '../components/List/components/ListPart/components/CanPublishPlatform.vue'
import DetailSpecificationButtons from './components/DetailSpecificationButtons.vue'
import SkuTable from './components/SkuTable.vue'
import PrivateAbnormal from './components/privateAbnormal.vue'
import DistributeAbnormal from './components/distributeAbnormal.vue'
import OperationalRecordCard from './components/OperationalRecordCard.vue'
import wxIcon from './img/erweima2x.png'
import { generateQrCodeUrl, getCooperationRelation, relationBind, purchaseCartAdd } from '@/api/distributor';
import {getShopItemDetail, getSupplierShopItemDetail, getShareShopItemDetail} from '@/servers/commodity/index.js'
import { getShopSettingConf } from '@servers/commodity'
import dayjs from 'dayjs'
import {get} from "lodash";
import ShopGoodsList from "@/pages/distributor/cooperation/supplierInfo/ShopGoodsList";
import { mapGetters } from 'vuex';
import no_pic from "@/assets/images/no_pic.png";
import { queryAmountDigit } from '@/api/base/index.js';
import { DEFAULT_AMOUNT_DIGIT } from '@/dictionary/index.js';

export default {
    name: 'myShopItemDetail',
    components: {
        DistributionPrice,
        CanPublishPlatform,
        DetailSpecificationButtons,
        SkuTable,
        ShopGoodsList,
        PrivateAbnormal,
        DistributeAbnormal,
        OperationalRecordCard,
    },
    props: {
      isSupplierProduct: {
        type: Boolean,
        default: false
      },
      identity: {
        type: String,
        default: ''
      },
      cardDetail: {
        type: Object,
        default: () => ({})
      },
      readonly: {
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            data: null,
            selectedSku: {},
            dialogVisible: false,
            dialogImageUrl: '',
            wxIcon,
            supplierCompanyId: this.$route.query.supplierId || '',
            isInCooperation: 0,
            loading:false,
            showList:{
                "distributePrice": false, // 分销价
                "commissionPrice": false, // 佣金
                "commissionScale": false, // 佣金比例
                "title": false, // 商品名称
                "outerId": false, // 款式编码
                "canPublish": false, // 可铺货平台
                "marketPrice": false, // 市场价
                "stock": false, // 库存
                "freightPrice": false, // 运费
            },
            skuConfigList:{},
            skuConfigWidthList:{},
            purchaseNum: 0,
            purchaseTotal: 0,
            priceTotal:'0.00',
            totalSelectedSku:[],
            showSkuList: false,
            itemList:[],
            errorSkuIds:[],
            no_pic,
            precision: '', // 分销商查询供销商商品时，对应供销商设置的金额精度
            skuFreightPrice:[],
        }
    },
    watch: {
      $route: {
        handler(val) {
          let id = get(val, 'query.supplierId', '')
          if (!id) {
            return;
          }
        },
        deep: true,
        immediate: true
      },
      // 监听用户登录状态
      userInfo: {
        handler(val) {
          if (!val || !val.companyId) {
            this.$nextTick(() => {
                this.checkLoginStatus();
            });
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
        this.getTabConfig()
    },
    computed: {
        ...mapGetters(['userInfo', 'amountDigit']),
        // 金额保留小数位数
        amountPrecision() {
            return this.precision !== '' ? this.precision : this.amountDigit;
        },
        yesterday() {
            return dayjs().subtract(1, 'day').format("YYYY-MM-DD")
        },
        carouselItems() {
            if (!this.data) return [];
            let videoList = this.data.videoList.filter(Boolean).map(item => {
                return {
                    ...item,
                    url: item.originUrl,
                    type: 'video'
                }
            })
            let imgList = this.data.mainImages.map(item => {
                return {
                    url: item,
                    type: 'img'
                }
            })

            
            // 将规格图加入到轮播列表中
            this.data.specifications && this.data.specifications.forEach(spec => {
                spec.values && spec.values.forEach(value => {
                    if(value.imageUrl && !imgList.some(img => img.url === value.imageUrl)) {
                        imgList.push({
                            url: value.imageUrl === '/resources/css/build/images/no_pic.png' ? this.no_pic : value.imageUrl,
                            type: 'img'
                        })
                    } else {
                        imgList.push({
                            url: this.no_pic,
                            type: 'img'
                        })
                    }
                })
            })
            return [...videoList, ...imgList]
        },
        isScm() {
          return window.location.host === 'scm.superboss.cc'
        },
        // 分销商查看供销商商品
        disToSupDetail() {
          return this.identity === 'disToSupplierDetail'
        },
        isSupplier(){
            return this.userInfo.loginIdentity === 1 ? true : false;
        },
        // 获取运费
        getFreightPrice(){ 
             let notFreightPrice = this.data.skuList.filter(sku => sku.freightPrice === null || sku.freightPrice === undefined);
            if(notFreightPrice.length === this.data.skuList.length){
                return '-';
            }
            // if(this.isSupplier){
                return this.skuFreightPrice[0]
            // }
            // return (this.selectedSku &&  this.selectedSku.freightPrice) || 0
        }
    },
    methods: {
        async getTabConfig(){
            // 获取供销商还是分销商版本
            let userInfo = this.$store.getters.userInfo;
            let isSupplier = userInfo.loginIdentity === 1 ? true : false;
            const companyId  = isSupplier ? this.userInfo.companyId : this.$route.query.supplierId;
            if(companyId){
                const res = await getShopSettingConf({companyId});
                let list = res.pcShopSetting.pcItemDetail.shopFieldConf || [];
                let skuConfig = res.pcShopSetting.pcSkuSetting.shopFieldConf || [];

                list.forEach(item=>{
                    this.showList[item.filed] = item.ifEnable;
                })
                skuConfig.forEach(item=>{
                    this.skuConfigList[item.filed] = item.ifEnable;
                    this.skuConfigWidthList[item.filed] = item.weight;
                })
                // 商品sku增加商品状态，但是装饰小店目前还没这个配置，加一个默认配置
                this.skuConfigList['skuActiveStatus'] = true;
                this.skuConfigWidthList['skuActiveStatus'] = 100;
            }
        },
        async getDetail() {
            if (!this.$route.params.id && !this.$route.query.productId && !this.$route.params.productId) {
                return this.$message.error('获取详情失败')
            }
            // 分销商查看供销商商品
            if (this.disToSupDetail) {
              this.data = await getSupplierShopItemDetail({
                baseItemId: this.$route.params.id || this.$route.query.productId || this.$route.params.productId || '',
                supplierCompanyId: this.$route.query.supplierId || '',
              })
             // 获取sku的运费
             let skuFreightPrice = this.data.skuList.map(sku => sku.freightPrice || 0).sort((a, b) => a - b);
             this.skuFreightPrice = [...new Set(skuFreightPrice)];
          
              
             
                // 如果是分销端查看自己的商品，不走这层逻辑，也就是 distributorCompanyId == supplierCompanyId
                if(this.userInfo.companyId != this.$route.query.supplierId) {
                    if(this.isInCooperation !== 2) {
                        if(this.data.privacyState == 1) {
                        this.$refs.privateAbnormal.method_open()
                        } else if(this.data?.distributionState == 2) {
                            this.$refs.distributeAbnormal.method_open()
                        }
                    } else {
                        // distributionState 0-待完善，1-可分销，2-不可分销
                        if(this.data?.distributionState == 2) {
                            this.$refs.distributeAbnormal.method_open()
                        }
                    }
                }


              
            } else if(this.identity == 'unLoginShare') {
                this.data = await getShareShopItemDetail({
                baseItemId: this.$route.params.id || this.$route.query.productId || this.$route.params.productId || '',
                supplierCompanyId: this.$route.query.supplierId || '',
              })
              this.$emit('abnormal',this.data)
            } else {
                this.data = await getShopItemDetail({
                    baseItemId: this.$route.params.id || this.$route.query.productId || this.$route.params.productId || '',
                })
                this.filterErpSku(this.data);
            }
        },

        // 过滤出绑定erp资料的sku
        filterErpSku(data){
            // 过滤出绑定erp资料的sku
            let skuList = data.skuList.filter(sku => sku.erpSysItemId);

            // 获取sku的运费
            let skuFreightPrice = data.skuList.map(sku => sku.freightPrice || 0).sort((a, b) => a - b);
            this.skuFreightPrice = [...new Set(skuFreightPrice)];
            // 过滤出skuList中skuSpecifications的值，放入colors数组
            let colors = skuList.reduce((acc, sku) => {
                let skuSpecifications = sku.skuSpecifications;
                if (skuSpecifications.length) {
                    let specValue = skuSpecifications.map(item => item.value);
                    acc.push(...specValue);
                }
                return acc;
            }, []);
            
            // 去重
            colors = [...new Set(colors)];

            // 过滤出specifications中value在colors中存在的元素
            data.specifications = data.specifications.map(spec => {
                if(spec.name === '颜色'){
                    return {...spec,values: spec.values.filter(v => colors.includes(v.value))};
                }
                return {...spec};
            });
            // 移除空的specifications
            data.specifications = data.specifications.filter(spec => spec.values.length > 0);
        },
        // 是否合作中的供销商
        async getIsInCooperation() {
            const res = await getCooperationRelation({
                distributorCompanyId: this.userInfo.companyId,
                supplierCompanyId: this.$route.query.supplierId || '',
            });
            // 0-未建立合作关系、1-待审核、11-待审核、12-待授权、2-已合作、3-已停止、4-已拒绝
            this.isInCooperation = get(res, 'data', 0);
            await this.getDetail();
        },
        specificationChange(sku, currentSpv) {
            console.log(sku, 'sku=-=-=-=-=-=-=-=-=-=');

            this.selectedSku = sku;
            // 规格变动，将轮播图定位到这张规格图
            if(currentSpv){
                let selectImg = currentSpv.imageUrl;
                let index = this.carouselItems.findIndex(item => item.url === selectImg);
                if(index !== -1) {
                    this.$nextTick(() => {
                        this.$refs.mainCarousel.setActiveItem(index);
                    });
                }
            }            

            // 规格变动，如果采购车中已有当前sku，获取采购的数量，没有则充值为0
            let existingIndex = this.findPurchaseExistingIndex();
            if(existingIndex !== -1) {
                this.purchaseNum = this.totalSelectedSku[existingIndex].num;
            } else {
                this.purchaseNum = 0;
            }
        },
       
        shelvesClick() {
            if(this.identity == 'unLoginShare') {
                this.$emit('login')
            } else {
                this.$refs.shopGoodsRef.rowClick('shelves', this.data)
            }
        },
        joinClick() {
          this.$refs.shopGoodsRef.rowClick('join', this.data)
        },
        updateClick() {
          this.$refs.shopGoodsRef.rowClick('update', this.data)
        },
        handleClickCarouselItem(item) {
            if (item.type === 'img') {
                this.openImgDialog(item.url)
            } else {
                window.open(item.url, '_blank')
            }
        },
        openImgDialog(url) {
            this.dialogVisible = true;
            this.dialogImageUrl = url || no_pic;
            if(this.identity == 'unLoginShare') {
                this.$emit('login')
            } else {
                // this.$refs.shopGoodsRef.rowClick('join', this.data)
            }
        },
        changeSkuListStatus(){
            this.showSkuList = !this.showSkuList;
        },
        // 移除对应的sku
        handleRemove(key){
            let existingIndex = this.totalSelectedSku.findIndex(sku => sku.key === key);
            this.totalSelectedSku.splice(existingIndex, 1);
            this.totalCalc();
        },
        // 找到对应的sku下标
        findPurchaseExistingIndex(){
            let existingIndex = this.totalSelectedSku.findIndex(sku => sku.key === this.selectedSku?.skuSpecifications.map(({value}) => value).join('-'));
            return existingIndex;
        },
        totalCalc(){
            this.purchaseTotal = +(this.totalSelectedSku.reduce((total, sku) => total + sku.num, 0));
            this.priceTotal = this.totalSelectedSku.reduce((total, sku) => total + (sku.levelDistributionPrice)*sku.num, 0).toFixed(2);
        },
        // 数量改变时
        changePurchaseNum(changeNum){
            if(+this.cardDetail.type === 22){
                this.$nextTick(() => {
                    this.purchaseNum = 1;
                });
                this.$confirm('您还没同供销商建立供分销关系，需合作后才能添加商品数量进行下单以及加入您的购物车，请先提交合作申请。', '提示', {
                    confirmButtonText: '立即申请',
                    cancelButtonText: '稍后再说',
                    type: 'warning'
                }).then(async () => {
                    const { companyId: distributorCompanyId } = this.userInfo;
                    let supplierCompanyId = get(this.$route, 'query.supplierId', '');
                    let res = await relationBind({
                        distributorCompanyId,
                        needAudit: 1,
                        supplierCompanyId,
                    })
                    if (res.result === 1) {
                        this.$message.success('已提交申请')
                    }
                });
                return;
            }else{
                this.$nextTick(() => {
                    this.purchaseNum = changeNum || 0;
                });
            }

            // 加入统计，如果TotalSelectedSku里面有对应的sku，覆盖，没有，添加
            if(this.data.pureType){ // 纯商品
                this.totalSelectedSku = [{
                    key: this.data.baseItemId,
                    baseItemId: this.data.baseItemId,
                    num: changeNum || 0,
                    skuId: 0,
                    outerId: this.data.outerId,
                    skuOuterId: this.data.skuOuterId,
                    type:1, // 1出货类型,2退货类型
                    imageUrl: this.data.mainImages[0],
                    levelDistributionPrice: this.data.levelDistributionPrice,
                    skuSpecifications: [],
                    skuSpecificationsStr: ''
                }]
                this.totalCalc();
                return;
            }

            // 非纯商品
            let existingIndex = this.findPurchaseExistingIndex();
            let item = {
                key: this.selectedSku?.skuSpecifications.map(({value}) => value).join('-'),
                baseItemId: this.selectedSku?.baseItemId,
                num: changeNum || 0, 
                skuId: this.selectedSku?.id,
                outerId: this.selectedSku?.outerId,
                skuOuterId: this.selectedSku?.skuOuterId,
                type:1, // 1出货类型,2退货类型
                imageUrl: this.selectedSku?.skuSpecifications[0].imageUrl,
                levelDistributionPrice: this.selectedSku?.levelDistributionPrice,
                skuSpecifications: this.selectedSku?.skuSpecifications,
                skuSpecificationsStr: this.selectedSku?.skuSpecifications.map(({value}) => value).join(',')
            }
            if(existingIndex !== -1) {
                if(item.num === 0){ // 若为0，删除
                    this.totalSelectedSku.splice(existingIndex, 1);
                }else{ // 若不为0，覆盖
                    this.totalSelectedSku[existingIndex] = item;
                    this.totalSelectedSku = [...this.totalSelectedSku];
                }
            } else {
                this.totalSelectedSku.push(item);
            }

            this.totalCalc();
            
        },
        async shoppingCartAdd(addType, data){
            let itemList=[];
            if(this.totalSelectedSku.length){ // 非纯商品加购
                let skuList = this.totalSelectedSku.map(sku => {
                    return {
                        skuId: sku.skuId,
                        num: sku.num,
                        type: sku.type,
                        pureType: 0,
                        numType: 1 // numType 0:赋值，1:增加
                    }
                })
                itemList = [{
                    supplierBaseItemId:data.baseItemId || '',
                    skuList
                }]
            }else{ // 纯商品加购
                itemList = [{
                    supplierBaseItemId:data.baseItemId || '',
                    skuList:[{
                        skuId: 0,
                        num: this.purchaseNum,
                        type: 1,
                        pureType: 1,
                        numType: 1 // numType 0:赋值，1:增加
                    }]
                }]
            }

            let params = {
                companyId: +this.$route.query.supplierId || '',
                itemList,
                distributorCompanyId: this.userInfo.companyId || '',
                supplierCompanyId: +this.$route.query.supplierId || ''
            }
            
            let res = await purchaseCartAdd(params, {isNeedLoading: true});
            if (res.result === 1) {
                let errormsg = '';
                this.errorSkuIds=[];
                (res.data?.itemList || []).forEach(item => {
                    if (errormsg) return;
                    if (item.showFailMessage) {
                        errormsg = item.showFailMessage;
                        item.skuDtos.forEach(sku => {
                            if(sku.skuFailMessage){
                                this.errorSkuIds.push(sku.skuId);
                            }
                        });
                    }
                });
                if (!errormsg) {
                    addType==='xd' ? "" : this.$message.success('加购成功');
                } else {
                    this.$message.error(errormsg);
                }
            }
        },
        async toShoppingCart(addType, data){
            await this.shoppingCartAdd(addType, data);
            let children = this.totalSelectedSku.map(sku => {
                return {
                    imageUrl: sku.imageUrl || no_pic,
                    num: sku.num,
                    price: sku.levelDistributionPrice,
                    skuId: sku.skuId,
                    skuOuterId: sku.skuOuterId,
                    outerId: sku.outerId,
                    skuSpecifications: sku.skuSpecificationsStr,
                    total: (sku.num * sku.levelDistributionPrice).toFixed(2) || '0.00',
                    pureType: sku.skuId === 0 ? 1 : 0
                }
            })
            let selectSkus = [{
                name: this.cardDetail.companyName,
                tableData:[{
                    baseItemId: data.baseItemId,
                    kuanCode: data.outerId,
                    name: data.title,
                    supplierCompanyId: data.companyId,
                    children
                }]
            }]
            if(this.errorSkuIds.length){
                return;
            }else{
                sessionStorage.setItem('selectSkus', JSON.stringify(selectSkus));
                this.$router.push({
                    path: `/distributor/supplier/orderConfirm`
                });
            }   
        },
        async querySupplierAmountDigit() {
            const data = await queryAmountDigit({companyId: this.$route.query.supplierId});
            this.precision = data;
        },
        handleOnCopy() {
            this.$message.success('复制成功');
        },
        // 检查登录状态
        checkLoginStatus() {
            if (!this.userInfo.companyId) {
                this.$confirm('您当前未登录，请先登录后再查看商品详情', '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning', 
                }).then(() => {
                    // 跳转到登录页面
                    this.$router.push('/login/index');
                }).catch(() => {
                    // 用户取消，可以选择返回上一页
                    this.$router.go(-1);
                });
            }
        },
    },
    mounted() {
        this.getIsInCooperation();
        if (this.$route.query.supplierId) {
            this.querySupplierAmountDigit();
        }
    },
}
</script>

<style lang="scss" scoped>
.myShopItemDetail {
    padding: 0 20px;

    .block-detail-main {
        display: flex;
        align-items: flex-start;
        margin: 0 auto;

        &_left {
            flex-basis: 400px;
            height: 400px;
            flex-shrink: 0;
            flex-grow: 1;

            .carouselImgWrap {
                width: 100%;
                height: 100%;
                position: relative;
                .carouselImg {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    cursor: pointer;
                }
                .video-icon-wrap {
                    cursor: pointer;
                    position: absolute;
                    font-size: 58px;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                }
            }
        }

        &_right {
            padding: 0 10px 0 20px;
            flex-grow: 2;
            .numCountRow {
                display: flex;
                &-item {
                    display: flex;
                    font-size: 14px;
                    margin-right: 20px;
                    
                    &_label {
                        color: #aaa;
                        margin-right: 5px;
                    }
                }
                .data-row_help {
                    color: #aaa;
                    margin-top: 1px;
                }
            }
            .gain{
                display: flex;                
                padding: 5px;
                font-size: 16px;
                font-weight: 500;
                .zuan,.yong{
                    padding: 3px 4px;
                    border-radius: 4px;
                    color:#fff;
                }
                .zuan{
                    background: #F9A809;
                    margin-right: 4px;
                }
                .num{
                 margin-right: 12px;
                }
                .yong{
                    background: #0AB1BC;
                    margin-right: 4px;
                }
            }

            .distributionPriceRow {
                background: #eee;
                padding: 10px 20px;
                margin-top: 10px;
                border-radius: 10px;

                .DistributionPrice {
                    color: #aaa;
                    font-size: 14px;
                }
            }

            .canPublish-platform-wrap {
                font-size: 14px;
                padding: 10px 20px;
            }
            .num-wrapper{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
            }
            .el-button-plain{
                background: #fff !important;
                color:#2695FA !important;
            }
            .skus-select-wraper{
                ::v-deep .el-table__row{
                    td{
                        border-right: 0px !important;
                    }
                }
                .red{
                    color: red;
                }
            }
            .total-wrapper{
                height:48px; 
                background:#eee; 
                display:flex; 
                align-items:center; 
                justify-content:space-between; 
                padding:0 20px; 
                font-size:14px;
                .left{
                    display:flex; 
                    align-items:center;
                    .total span{
                        color:#2695FA
                    }
                    .line{
                        margin:0 24px; 
                        height:32px;
                        border-left:1px solid #DFE2E8;
                        border-radius: 4px 4px 0px 0px;
                    }
                    .price{
                        color:#2695FA;
                        font-weight:bold;
                        .num1{
                            font-size:26px
                        }
                        .num2{
                            font-size:18px
                        }
                    }
                }
                .right{
                    cursor:pointer;
                    i{
                        color:#8C8C8C;margin-left:4px
                    }
                }
            }
        }
    }

    .block-detail-des {
        background: #eee;
        padding: 10px 20px;
        margin-top: 10px;
        font-size: 14px;

        &_label {
            color: #aaa;
        }
    }

    .block-detail-spTable {
        margin-top: 10px;
    }
    .block-detail-desImgs {
        margin-top: 10px;
        &_img {
            min-height: 100px;
            display: block;
            text-align: center;
            ::v-deep .el-image__inner {
                width: auto;
            }
        }
    }
}
::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 5px;
}
</style>
